import type { IStringifyOptions } from 'qs'
import qs from 'qs'

export const stringifyUrl = ({
  url,
  query,
  queryOptions,
  fragmentIdentifier,
}: {
  url: string
  query?: any
  queryOptions?: IStringifyOptions
  fragmentIdentifier?: string
}) => {
  const c = new URL(url)
  c.search = qs.stringify(query || {}, { arrayFormat: 'brackets', ...queryOptions }) || ''
  c.hash = fragmentIdentifier || ''
  return String(c)
}
